import React, { useState, useCallback } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MapPage from './pages/MapPage';
import CookieBanner from './components/CookieBanner';
import OnboardingPage from './pages/OnboardingPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AGBPage from './pages/AGBPage';
import { useAuth } from './contexts/AuthContext';
import ToastContainer from './components/ToastContainer';
import { fixRussianLanguage } from './russianFix';
import PerformanceDashboard from './components/PerformanceDashboard';
import { useMemoryCleanup, useComponentLifecycle } from './hooks/usePerformanceOptimization';

// React.memo verhindert unnötige Re-Renders der geschützten Routen.
const ProtectedRoute = React.memo(({ element }) => {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    
    if (isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.2em', color: '#6366f1', backgroundColor: '#fafbfc', fontWeight: '600' }}>Loading Identity...</div>;
    }
    if (!isAuthenticated) {
        // Redirect to start but remember the original location
        return <Navigate to="/start" replace state={{ from: location }} />;
    }
    return element;
});

function App() {
    const { isAuthenticated } = useAuth();
    const [showPerformanceDashboard, setShowPerformanceDashboard] = useState(false);
    
    // Performance Optimization
    const { addTimer, addInterval, addListener } = useMemoryCleanup();
    useComponentLifecycle('App');

    // Performance Dashboard Toggle (Ctrl+Shift+P)
    const handleKeyPress = useCallback((event) => {
        if (event.ctrlKey && event.shiftKey && event.key === 'P') {
            event.preventDefault();
            setShowPerformanceDashboard(prev => !prev);
        }
    }, []);

    // Keyboard Event Listener mit Memory Cleanup
    React.useEffect(() => {
        addListener(document, 'keydown', handleKeyPress);
    }, [handleKeyPress, addListener]);

    // Russisch-Fix beim App-Start (innerhalb Component)
    React.useEffect(() => {
        fixRussianLanguage();
    }, []);

    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <CookieBanner />
            <ToastContainer />
            <PerformanceDashboard 
                isVisible={showPerformanceDashboard} 
                onClose={() => setShowPerformanceDashboard(false)} 
            />
            <Routes>
                <Route path="/start" element={<OnboardingPage />} />
                <Route path="/" element={<ProtectedRoute element={<MapPage />} />} />
                <Route path="/event/:id" element={<ProtectedRoute element={<MapPage />} />} />
                <Route path="/gonkle/:id" element={<ProtectedRoute element={<MapPage />} />} />
                <Route path="/impressum" element={<ImpressumPage />} />
                <Route path="/datenschutz" element={<DatenschutzPage />} />
                <Route path="/agb" element={<AGBPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
}
export default App;
